import { defineStyleConfig } from "@chakra-ui/react";

export const checkboxTheme = defineStyleConfig({
	baseStyle: {
		control: {
			height: "16px",
			width: "16px",
			borderRadius: "2px",
			position: "relative",
			border: "1px solid",
			borderColor: "neutrals.100",
			svg: {
				zIndex: 9,
			},
			_invalid: {
				border: "1px solid",
				borderColor: "accent.red.400",
			},
			_disabled: {
				borderColor: "neutrals.50",
				background: "neutrals.50",
			},
			_checked: {
				borderColor: "brand.400",
				_before: {
					content: "''",
					position: "absolute",
					width: "100%",
					height: "100%",
					background: "brand.400",
				},
				_disabled: {
					svg: {
						color: "neutrals.200",
					},
					_before: {
						background: "neutrals.40",
					},
					border: "1px solid accent.neutrals.500",
				},
			},
			_focus: {
				boxShadow: "outline",
			},
		},
		icon: {
			height: "11px",
			width: "8px",
			marginBottom: "1px",
			color: "neutrals.0",
		},
		label: {
			_checked: {
				_disabled: {
					color: "text.title",
				},
			},
			_disabled: {
				color: "neutrals.200",
			},
		},
	},
});
